
import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Container, Row, Col, Input, Button, Table } from 'reactstrap';

export class ModalError extends Component {
	render() {
    const {url, errorText, payload} = this.props.error;
		return (
			<div>
				<Modal isOpen={true} toggle={null} style={{ minWidth: '700px'}} className={'modal-error'}>
					<ModalHeader>
						Error
					</ModalHeader>
					<ModalBody style={{padding: '10px 8px'}}>
						<Container>
              <span style={{fontWeight: 600}}>{url}</span>

              <br/><br/>

              <span style={{color: 'red'}}>
                {errorText}
              </span>

              <br/><br/>
              <span style={{fontWeight: 600}}>{'Input JSON'}</span>
              <br/>
							
              <pre>{payload && JSON.stringify(JSON.parse(JSON.parse(payload)), null, 2)}</pre>

              <br/><br/>
              <small 
                style={{color: 'red'}}
              >
                Disable debugging modal from: {'IISFolder/<site-client>/config-env.json'} setting debug: false
              </small>
						</Container>
					</ModalBody>
					<ModalFooter>
						<Button color="warning" onClick={() => window.location.reload(true)}>Refresh or F5</Button>
					</ModalFooter>
				</Modal>
			</div>
		);
	}
}